import React, { Component } from "react";
import { connect } from "react-redux";

import { Style } from "react-style-tag";
import { withStyles } from "@material-ui/core/styles";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import LinearProgress from "@material-ui/core/LinearProgress";
import Button from "@material-ui/core/Button";
import { withRouter } from "react-router-dom";

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
    cursor: "pointer",
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const CloseButton = withStyles(styles)((props) => {
  const { children, classes, onClose, banner, ...other } = props;
  return onClose ? (
    <>
      {banner.type == "Image" && (
        <Style>
          {`
          [class*='Component-closeButton-'] {
              color: #f5f5f5!important;
              background: rgba(0,0,0,0.3)!important;
          }
          [class*='Component-closeButton-']:hover {
              background: rgba(0,0,0,0.6)!important;
          }
          `}
        </Style>
      )}
      <IconButton
        aria-label="close"
        className={classes.closeButton}
        onClick={onClose}
        style={{
          left: props.language == "arabic" ? "0" : "initial",
        }}
      >
        {banner.type == "Redirect" ? (
          props.language == "arabic" ? (
            <ChevronLeftIcon />
          ) : (
            <ChevronRightIcon />
          )
        ) : (
          <CloseIcon />
        )}
      </IconButton>
    </>
  ) : null;
});

function CustomizedDialogs({
  banner,
  open,
  handleClose,
  windowType,
  ...props
}) {
  const isRequiredConfirmation = banner.type === "Required Confirmation";
  let declineRedirectLink = null;
  try {
    const declineUrl = new URL(banner.redirect_link);
    if (["http:", "https:"].includes(declineUrl.protocol)) {
      declineRedirectLink = declineUrl.href;
    }
  } catch (_) {}

  const decline = () => {
    if (declineRedirectLink) {
      window.location.href = declineRedirectLink;
      return;
    }

    window.open("", "_self");
    window.close();
    setTimeout(() => {
      if (!window.closed) window.location.replace("about:blank");
    }, 100);
  };

  let close = () => {
    if (banner.type == "Redirect")
      if (
        banner.redirect_link.startsWith(window.location.origin) &&
        !["grid", "grid2", "scroll"].includes(props.settings.store_layout) &&
        !banner.redirect_link.includes("/product")
      ) {
        let link = banner.redirect_link.replace(window.location.origin, "");
        link = link.replace(/^https?:\/\//i, "");
        handleClose();
        props.history.push(link);
      } else {
        window.location.href = banner.redirect_link;
      }
    handleClose();
    sessionStorage.setItem(`hideBanner${banner.id}`, true);
  };

  const [progress, setProgress] = React.useState(0);

  React.useEffect(() => {
    let timer = null;
    setProgress(0);
    if (banner.autoclose && !isRequiredConfirmation) {
      timer = setInterval(() => {
        setProgress((oldProgress) => {
          if (oldProgress >= 100) {
            clearInterval(timer);
            close();

            return 100;
          }
          const diff = 10 / banner.autoclose_timer;
          return Math.min(oldProgress + diff, 100);
        });
      }, 100);
    }
    return () => {
      clearInterval(timer);
    };
  }, [banner]);

  return (
    <div>
      <Dialog
        onClose={isRequiredConfirmation ? undefined : close}
        aria-labelledby="customized-dialog-title"
        aria-modal="true"
        open={open}
        maxWidth="lg"
        disableBackdropClick={isRequiredConfirmation}
        disableEscapeKeyDown={isRequiredConfirmation}
        // fullWidth={true}
        fullScreen={false}
        style={{ background: "transparent" }}
        PaperProps={{
          style: {
            backgroundColor: banner.type === "Image" ? "transparent" : "",
          },
        }}
      >
        {banner.type === "Image" && (
          <div>
            <img
              style={{
                width: "100%",
                height: "auto",
                maxWidth: 700,
              }}
              src={banner.image}
              alt="Store banner"
            />
            {banner.redirect_link && (
              <div>
                <Button
                  autoCapitalize
                  style={{
                    backgroundColor: props.themeColor,
                    padding: "10px",
                    textAlign: "center",
                    marginTop: "10px",
                    borderRadius: "5px",
                    width: "100%",
                    height: "100%",
                    textTransform: "none",
                  }}
                  color="primary"
                  variant="contained"
                  onClick={() => {
                    if (
                      banner.redirect_link.startsWith(window.location.origin) &&
                      !["grid", "grid2", "scroll"].includes(
                        props.settings.store_layout
                      ) &&
                      !banner.redirect_link.includes("/product")
                    ) {
                      let link = banner.redirect_link.replace(
                        window.location.origin,
                        ""
                      );
                      link = link.replace(/^https?:\/\//i, "");
                      handleClose();
                      props.history.push(link);
                    } else {
                      window.location.href = banner.redirect_link;
                    }
                    sessionStorage.setItem(`hideBanner${banner.id}`, true);
                  }}
                >
                  {!banner.title_ar && !banner.title
                    ? props.language === "arabic"
                      ? "إعادة التوجيه"
                      : "Redirect"
                    : props.language === "arabic" && banner.title_ar
                    ? banner.title_ar
                    : banner.title}
                </Button>
              </div>
            )}
          </div>
        )}

        {banner.type == "Notice" && (
          <>
            <DialogTitle
              id="customized-dialog-title"
              onClose={close}
              style={{
                textAlign: props.language == "arabic" ? "right" : "left",
                minWidth: 310,
                maxWidth: "90vw",
              }}
            >
              {(props.language == "arabic" && banner.title_ar) || banner.title}
            </DialogTitle>
            <DialogContent dividers>
              <div
                style={{
                  textAlign: props.language == "arabic" ? "right" : "left",
                }}
                dangerouslySetInnerHTML={{
                  __html:
                    props.language == "arabic"
                      ? banner.content_ar
                      : banner.content,
                }}
              ></div>
            </DialogContent>
          </>
        )}
        {isRequiredConfirmation && (
          <>
            <DialogTitle
              id="customized-dialog-title"
              style={{
                textAlign: props.language == "arabic" ? "right" : "left",
                minWidth: 310,
                maxWidth: "90vw",
              }}
            >
              {(props.language == "arabic" && banner.title_ar) || banner.title}
            </DialogTitle>
            <DialogContent dividers>
              <div
                style={{
                  textAlign: props.language == "arabic" ? "right" : "left",
                }}
                dangerouslySetInnerHTML={{
                  __html:
                    props.language == "arabic"
                      ? banner.content_ar
                      : banner.content,
                }}
              />
            </DialogContent>
            <MuiDialogActions>
              <Button
                variant="contained"
                onClick={decline}
                style={{
                  backgroundColor: "#d32f2f",
                  color: "#fff",
                  margin: 8,
                  textTransform: "none",
                }}
              >
                {props.language == "arabic"
                  ? banner.decline_button_text_ar || "رفض"
                  : banner.decline_button_text || "Decline"}
              </Button>
              <Button
                color="primary"
                variant="contained"
                onClick={close}
                style={{
                  backgroundColor: props.themeColor,
                  margin: 8,
                  textTransform: "none",
                }}
              >
                {props.language == "arabic"
                  ? banner.confirm_button_text_ar || "أوافق"
                  : banner.confirm_button_text || "I Agree"}
              </Button>
            </MuiDialogActions>
          </>
        )}
        {banner.type == "Redirect" && (
          <>
            <DialogTitle
              id="customized-dialog-title"
              onClose={close}
              style={{
                textAlign: props.language == "arabic" ? "right" : "left",
                minWidth: 310,
                maxWidth: "90vw",
              }}
            >
              <b>
                {props.language == "arabic"
                  ? banner.autoclose
                    ? "إعادة التوجيه الى"
                    : "إعادة التوجيه"
                  : banner.autoclose
                  ? "Redirecting"
                  : "Redirect"}
              </b>
            </DialogTitle>
            <DialogContent dividers>
              <div
                dangerouslySetInnerHTML={{
                  __html:
                    props.language == "arabic"
                      ? banner.content_ar
                      : banner.content,
                }}
                style={{
                  textAlign: props.language == "arabic" ? "right" : "left",
                }}
              ></div>
            </DialogContent>
          </>
        )}
        {!isRequiredConfirmation && (
          <CloseButton
            onClose={close}
            banner={banner}
            language={props.language}
          />
        )}
        {!!banner.autoclose && !isRequiredConfirmation && (
          <Box sx={{ width: "100%" }}>
            <LinearProgress variant="determinate" value={progress} />
          </Box>
        )}
      </Dialog>
    </div>
  );
}

class index extends Component {
  state = {
    open: false,

    banners: [],
    currentBanner: 0,

    type: null, // image, consent, notice, products, redirect
    autoclose: 0,

    imageURL: null,
    title: null,
    content: null,
    redirectURL: null,
  };

  async componentDidMount() {
    let banners = this.props.settings.popup_banner
      .filter((banner) =>
        this.props.isB2B ? banner.is_b2b : !banner.is_b2b
      )
      .filter(
        (banner) => !sessionStorage.getItem(`hideBanner${banner.id}`)
      )
      .sort(
        (a, b) =>
          Number(b.type === "Required Confirmation") -
          Number(a.type === "Required Confirmation")
      );
    await this.setState({ banners });

    if (this.state.banners?.length) {
      const firstBanner = this.state.banners[0];
      this.setState({
        type: firstBanner.type,
        imageURL: firstBanner.image,
        open: true,
        currentBanner: 0,
      });
    }
  }

  onClose = () => {
    this.setState({ open: false }, () => {
      setTimeout(() => {
        if (this.state.banners.length >= this.state.currentBanner) {
          this.setState({
            open: true,
            currentBanner: this.state.currentBanner + 1,
          });
        }
      }, 200);
    });
  };

  render() {
    const { themeColor, language, domain, history, settings } = this.props;
    const { open } = this.state;

    const banner = this.state.banners.length
      ? this.state.banners[this.state.currentBanner]
      : null;

    const showBanner =
      banner &&
      banner.redirect_link !== window.location.href &&
      !sessionStorage.getItem(`hideBanner${banner.id}`);

    return (
      <>
        {banner && showBanner && (
          <CustomizedDialogs
            open={open}
            handleClose={this.onClose}
            windowType={!!banner.window_mode}
            banner={banner}
            {...this.state}
            language={language}
            themeColor={themeColor}
            history={history}
            settings={settings}
          />
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    themeColor: state.store.store.settings.dark || "#0099cc",
    settings: state.store.store.settings,
    isB2B: state.store.isB2B,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(index));
